module.exports = __webpack_public_path__ + "img/back.38457d05.png";